import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { LAYOUT } from "./constants.js";
function PageFooter({ pageNumber, isEven, bookLabel, footerTop, bleedPx = 0 }) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: "absolute",
      style: {
        top: footerTop + bleedPx,
        ...isEven ? { left: LAYOUT.footer.sideMargin + bleedPx } : { right: LAYOUT.footer.sideMargin + bleedPx }
      },
      children: /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-[8px]", children: [
        /* @__PURE__ */ jsx("span", { style: { fontSize: 16, fontWeight: 600, color: "#000", letterSpacing: "-0.096px" }, children: pageNumber }),
        isEven && bookLabel && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx("div", { style: { width: 1, height: 10, backgroundColor: "#999" } }),
          /* @__PURE__ */ jsx("span", { style: { fontSize: 14, color: "#000", letterSpacing: "-0.084px" }, children: bookLabel })
        ] })
      ] })
    }
  );
}
export {
  PageFooter
};
//# sourceMappingURL=PageFooter.js.map
